/*
 * @Author: zhangweinan
 * @Date: 2022-10-08 16:29:28
 * @LastEditors: WeijianXu weijian.xu@unidt.com
 * @LastEditTime: 2024-04-10 15:15:52
 * @Description: file content
 * @FilePath: /user-center/src/data/ApiUser.js
 */
import request from '@/core/request.js';
//登录
export const login = ({ passWord, phone, loginType }) =>
  request({
    url: '/account-entity/login',
    method: 'post',
    data: { passWord, phone, loginType },
  });

//登出
export const logout = () =>
  request({
    url: '/account-entity/loginOut',
    method: 'post',
  });

//获取用户信息
export const getUserInfo = (data) =>
  request({
    url: '/account-entity/findByToken',
    method: 'post',
    data,
  });

//获取企业用户信息
export const getEUserInfo = (data) =>
  request({
    url: '/euser/detail',
    method: 'post',
    data,
  });

//修改用户密码
export const updatePasswordUser = ({ phid, newPassWord, passWord }) =>
  request({
    url: '/auser-entity/updatePassWord',
    method: 'post',
    data: { phid, newPassWord, passWord },
  });

//获取用户信息（通过userId）
export const getUserInfoByUid = (userId) =>
  request({
    url: '/account-entity/findByUserId',
    method: 'post',
    data: { userId },
  });

//根据角色id获取菜单权限(roleId)
export const getListByRole = (roleId) =>
  request({
    url: `/role-perm-entity/listByRoleId`,
    method: 'post',
    data: roleId,
  });

// 验证申请单
export const euserValidate = (params) =>
  request({
    url: '/euser/validate',
    method: 'get',
  });

//验证 个人/企业 认证
export const getAuthenValidate = (params) =>
  request({
    url: '/authentication/validate',
    method: 'get',
  });

//个人认证
export const personalAuthentication = (data) =>
  request({
    url: '/authentication/personal_authentication',
    method: 'post',
    data,
  });

//企业认证
export const enterpriseAuthentication = (data) =>
  request({
    url: '/authentication/enterprise_authentication',
    method: 'post',
    data,
  });

//认证信息
export const authenticationInfo = (type) =>
  request({
    url: `/authentication/authenticationInfo/${type}`,
    method: 'get',
  });
